module.exports = __webpack_public_path__ + "static/gauley-4ea5fb7593a5dbd5fe7fd3ba77ba666b.jpg";